import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import FormatUtils from '../utils/utils-format';
import MetadataUtils from '../utils/utils-metadata';
import { ProductMetaData } from '../../../models/Product';
import { useLanguage } from '../../contexts/language';
import { ProductClass } from '../../store/constants';

type Props = {
    readonly product?: Pick<ProductMetaData, 'productClass' | 'seriesName' | 'seriesNumber'>;
    // FIXME: should not be optional and should be taken from `product`
    readonly loanFormatKey: string | null | undefined;
    readonly linked?: boolean;
    readonly isOrderDetail?: boolean;
    readonly className?: string;
    readonly onMouseEnter?: () => void;
};

export const ProductSeries: FC<Props> = ({
    product = {},
    loanFormatKey,
    linked = true,
    isOrderDetail = false,
    className = 'series',
    onMouseEnter
}) => {
    const { productClass, seriesName, seriesNumber } = product;
    const language = useLanguage();

    if (!seriesName) {
        return null;
    }

    const seriesLabel = seriesNumber ? `${seriesName} - Book ${seriesNumber}` : seriesName;

    if (isOrderDetail) {
        return <p className={className}>{FormatUtils.truncate(seriesLabel)}</p>;
    }

    const linkTo = MetadataUtils.createMetaDataLink(
        productClass as ProductClass,
        { series: { include: [seriesName] } },
        { language, loanFormatKey }
    );

    return (
        <p onMouseEnter={onMouseEnter} className={className}>
            {linked ? <Link to={linkTo}>{FormatUtils.truncate(seriesLabel)}</Link> : FormatUtils.truncate(seriesLabel)}
        </p>
    );
};

export default ProductSeries;
